module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-wrapper"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('label', {
    attrs: {
      "for": "panel-toggle",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closePanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-MBR_close",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.content.about_label)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-content",
    attrs: {
      "data-simplebar": ""
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inner"
  }, [((_vm.content.about_heading_1 || _vm.content.about_body_1)) ? _c('section', [(_vm.content.about_heading_1) ? _c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.content.about_heading_1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.about_body_1) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.about_body_1)
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.content.about_heading_2 || _vm.content.about_body_2)) ? _c('hr') : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.content.about_heading_2 || _vm.content.about_body_2)) ? _c('section', [(_vm.content.about_heading_2) ? _c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.content.about_heading_2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.about_body_2) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.about_body_2)
    }
  }) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72eeb05c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PanelContentAbout.vue
// module id = 466
// module chunks = 1